
    <div class="row" provideParentForm>
    

      <div class="col-8 position-relative">

          <input class="form-control"
                 [placeholder]="placeHolder ? placeHolder : 'd/m/yyyy'"
                 [name]="label"
                 *ngIf="selectedDateType == DateType.Gregorian"
                 [(ngModel)]="selectedDate"
                 ngbDatepicker (click)="d.toggle()"
                 (dateSelect)="dateSelected()"
                 autocomplete="off"
                 [readonly]="readonly"
                 [minDate]="minGreg"
                 [maxDate]="maxGreg"
                 [required]="isRequired"
                 [disabled]="disabled"
               (keypress)="$event.preventDefault()"
                 #d="ngbDatepicker">
         
        
          <hijri-date-picker *ngIf="selectedDateType == DateType.Hijri"
                             [(selectedDate)]="selectedDate"
                             (selectedDateChange)="dateSelected()"
                             [readonly]="readonly"
                             [min]="minHijri" [max]="maxHijri"
                             style="position: relative;flex: 1 1 auto;width: 1%; min-width: 0;margin-bottom: 0;"
                             [name]="label"
                             [isRequired]="isRequired"
                             [placeHolder]="placeHolder"
                             [disabled]="disabled">
          </hijri-date-picker>
      </div>
          <div class="col-4 row" *ngIf="!disabled">
                  <span *ngIf="!disabled" class="col-6 btn btn-sm {{selectedDateType == DateType.Hijri ? 'btn-primary focus active' :  'btn-outline-primary'}}" (click)="hijriClick()"   >
                     {{hijriLabel ? hijriLabel : 'هـ' }}
                  </span>
                  <span *ngIf="!disabled" class="col-6 btn btn-sm {{selectedDateType == DateType.Gregorian ? 'btn-primary focus active' :  'btn-outline-primary'}}" (click)="gregClick()"  >
                      {{GregLabel ? GregLabel : 'م' }}
                  </span>
           </div>

      
  </div>
